import { useCallback, useContext } from 'react';
import AuthContext from '../context/authContext';
import useHttp from './useHttp';

const useBulkCommunication = () => {
  const { getAuthHeaders } = useContext(AuthContext);
  const { sendRequest } = useHttp();

  const getMeta = useCallback(async () => {
    return await sendRequest({
      url: '/api/v1/bulkCommunication/meta',
      method: 'GET',
      headers: getAuthHeaders(),
    });
  }, [getAuthHeaders, sendRequest]);

  const previewRecipients = useCallback(
    async ({ entertainmentId, fromDate, toDate }) => {
      return await sendRequest({
        url: '/api/v1/bulkCommunication/preview',
        method: 'POST',
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'application/json',
        },
        body: {
          entertainmentId,
          fromDate,
          toDate,
        },
      });
    },
    [getAuthHeaders, sendRequest]
  );

  const sendBulkMail = useCallback(
    async ({ entertainmentId, fromDate, toDate, subject, bodyText }) => {
      return await sendRequest({
        url: '/api/v1/bulkCommunication/mail/send',
        method: 'POST',
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'application/json',
        },
        body: {
          entertainmentId,
          fromDate,
          toDate,
          subject,
          bodyText,
        },
      });
    },
    [getAuthHeaders, sendRequest]
  );

  const sendBulkSms = useCallback(
    async ({ entertainmentId, fromDate, toDate, bodyText }) => {
      return await sendRequest({
        url: '/api/v1/bulkCommunication/sms/send',
        method: 'POST',
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'application/json',
        },
        body: {
          entertainmentId,
          fromDate,
          toDate,
          bodyText,
        },
      });
    },
    [getAuthHeaders, sendRequest]
  );

  return {
    getMeta,
    previewRecipients,
    sendBulkMail,
    sendBulkSms,
  };
};

export default useBulkCommunication;
